import { Injectable } from '@angular/core';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { ListItem } from '../../../../../../libs/Shared/components/model/listItem';

@Injectable({
  providedIn: 'root',
})
export class SiteDataService {
  options = { authenticate: true, setRoot: true };

  constructor(private api: GatewayAPIService) {}

  getMerchantBrandListItems(): Promise<ListItem[]> {
    return this.getListItems('/admin/brands');
  }

  getMerchantGroupListItems(): Promise<ListItem[]> {
    return this.getListItems('/admin/groups');
  }

  getProcessorListItems(): Promise<ListItem[]> {
    return this.getListItems('/admin/processors');
  }

  getGatewayListItems(): Promise<ListItem[]> {
    return this.getListItems('/admin/gateways');
  }

  private getListItems(endpoint: string): Promise<ListItem[]> {
    return this.api
      .apiCallSane(
        endpoint,
        'GET',
        this.api.getDefaultHeaders(),
        null,
        null,
        this.options,
      )
      .then((response: Partial<ListItem>[]) =>
        response.map((s) => new ListItem(s)),
      );
  }
}
